<script>
export default {
  props: {
    columns: Array,
    dataSource: Array,
  },
  render() {
    const on = {
      ...this.$listeners,
    };
    const props = {
      ...this.$attrs,
      ...this.$props,
      ...{
        dataSource: this.dataSource,
        columns: this.columns,
      },
      size: "middle",
      pagination: false,
      rowKey: (record, index) => {
        return index;
      },
    };
    if (!this.$attrs.scroll) {
      // props.scroll = { x: 800 };
    }
    const slots = Object.keys(this.$slots).map((slot) => {
      return <template slot={slot}>{this.$slots[slot]}</template>;
    });
    const table = (
        <a-table props={props} scopedSlots={this.$scopedSlots} on={on}>
          {slots}
        </a-table>
    );
    return <div class="common-table">{table}</div>;
  },
};
</script>
<style lang="scss" scoped>
.common-table {
  padding-bottom: 100px;
}
</style>
